import * as React from 'react'

import { IIcon } from '.'

export const Copy: React.FCC<IIcon> = ({
  size = { x: 24, y: 24 },
  className = '',
}) => (
  <svg
    className={className}
    width={size.x}
    height={size.y}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 2H10V10H2V2Z" stroke="black" strokeLinecap="square" />
    <path
      d="M12 6H14V14H6V12"
      stroke="black"
      strokeLinecap="square"
      strokeDasharray="2 2"
    />
  </svg>
)

Copy.displayName = 'Copy'
